module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ca-AD.json
// module id = 1467
// module chunks = 22